import Web3 from 'web3';
import {web3} from '../web3.js';
import NoteSequencesContract from '../contracts/NoteSequencesContract.js';

var contract = new NoteSequencesContract();

class NoteSequencePublisher {
    constructor() {
        this.contract = new web3.eth.Contract(contract.abi, contract.contractAddress);
        this.ethAddress = this.contract.options.address;
    }

    publish(args) {
        return new Promise(async (resolve, reject) => {
            const accounts = await web3.eth.getAccounts();
            this.contract.methods.newNoteSequenceLarge(args[0], args[1], args[2], args[3], args[4])
                .send({
                    from: accounts[0] 
                }, (error, transactionHash) => {
                if (error) {
                    reject(error);
                } else {
                    resolve();
                }
                });
        });
    }
}

export default NoteSequencePublisher;
